var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-layout"},[_c('div',{staticClass:"l"},[_vm._t("l")],2),_c('div',{staticClass:"r"},[_vm._t("r")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }